import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TitleStrategy, RouterStateSnapshot } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TranslateTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    readonly translateService: TranslateService)
  {
    super();
  }

  override async updateTitle(routerState: RouterStateSnapshot) {
    const titleKey = this.buildTitle(routerState);
    if (titleKey !== undefined) { // when titleKey is undefined, the title is set in breadcrumbs.component.ts
      const translations = await forkJoin([
         this.translateService.get(titleKey),
         this.translateService.get('title')
       ]).toPromise() as [string, string];
      const [ pageTitle, solutionTitle ] = translations;
      const title = `${pageTitle} - ${solutionTitle}`;
      this.title.setTitle(title);
    }
  }
}
